import React, { useState, useEffect, useRef } from 'react'

// Functions
import pxToRem from '../../functions/px-to-rem'

export const Collapser = ({ onOpen, onClose, html, children, ...props }) => {
	const Tag = props.tag;
	const HeadingTag = props.heading;

	const propOpen = props.open;

	const mounted = useRef(false);
	const wrapElem = useRef(false);

	const [open, setOpen] = useState(props.open);

	const [active, setActive] = useState(props.open);
	const [show, setShow] = useState(props.open);
	const [contentHeight, setContentHeight] = useState(props.open ? 'none' : '0');

	useEffect(() => {
		mounted.current = true;

		return (() => {
			mounted.current = false;
		})
	}, []);

	useEffect(() => {
		setOpen(propOpen);
	}, [propOpen])

	useEffect(() => {
		if(onOpen && !active && open) {
			onOpen();
		}
		else if(onClose && active && !open) {
			onClose();
		}
	}, [active, open, onOpen, onClose])

	useEffect(() => {
		if(show && mounted.current && wrapElem.current) {
			setContentHeight(pxToRem(wrapElem.current.clientHeight) + 'rem');
		}
	}, [show])

	useEffect(() => {
		if (open) {
			setActive(true);

			setTimeout(() => {
				if (open && mounted.current && wrapElem.current) {
					setContentHeight(pxToRem(wrapElem.current.clientHeight) + 'rem');
					setShow(true);
				}
			}, 30);
		}
		else {
			setShow(false);

			setContentHeight('0');
			setTimeout(() => {
				if (mounted.current && !open) {
					setActive(false);
				}
			}, 300);
		}
	}, [open]);

	return (
		<Tag
			id={props.id}
			className={"collapser " + props.className + (active ? ' active' : '') + (show ? ' show' : '')}>
			<button className="collapser-btn" type="button" onClick={() => { setOpen(!open); }}>
				<HeadingTag className="btn-text">{props.title}</HeadingTag>
			</button>

			<div
				className="collapser-content"
				style={{ maxHeight: contentHeight }}>
				<div
					className={"collapser-innerwrap" + (props.wysiwyg ? ' wysiwyg' : '')}
					dangerouslySetInnerHTML={html ? {__html: html } : undefined}
					children={!html ? children : undefined}
					ref={wrapElem} />
			</div>
		</Tag>
	)
}

Collapser.defaultProps = {
	className: '',
	title: '!!Props.Title!!',
	wysiwyg: false,
	heading: 'h2',
	tag: 'div',
	open: false,
	html: false,
}

export default Collapser;